
import {Component, Vue} from 'vue-property-decorator'
import { downloadUrl } from '@/utils/util'

@Component
export default class ImagePreview extends Vue {
  downloadUrl = downloadUrl
  visiable = false
  initialSwipe = 0
  imageList = []

  showModal (imageList: [], initialSwipe: number) {
    this.imageList = imageList
    this.initialSwipe = initialSwipe
    this.visiable = true
  }
}
